import React from 'react';
import PropTypes from 'prop-types';
import RecommendedLabel from '../../recommendedLabel/RecommendedLabel';

const CardTitle = ({ props }) => {
    const { recommended, index, cardTitle } = props;
    return (
        <div className="card__title" data-cy="contactcard-headline">
            {!recommended && index === 0 && <RecommendedLabel />}
            <h2>{cardTitle}</h2>
        </div>
    );
};
CardTitle.propTypes = {
    props: PropTypes.object,
    recommended: PropTypes.string,
    index: PropTypes.number,
    cardTitle: PropTypes.string,
};
export default CardTitle;
